module.exports = __webpack_public_path__ + "img/9a1db75.png";